import { CHANNEL_TYPES_BY_BOT_TYPE } from '@/utils/channel.constants'

// Org channels the given bot could be deployed to: only the channel family matching the bot's type,
// each tagged with the bot it is currently bound to (from bots[].channels). A bound channel is still
// listed so the user sees where it lives, but it is not deployable - a channel belongs to one bot.
export function buildDeployableChannels(channels = [], bots = [], bot = {}) {
  const allowedTypes = CHANNEL_TYPES_BY_BOT_TYPE[bot.type] || []
  const boundBotByChannelId = new Map()
  bots.forEach(candidate => (candidate.channels || []).forEach(channel => boundBotByChannelId.set(channel.id, candidate)))

  return channels
    .filter(channel => allowedTypes.includes(channel.type))
    .map(channel => {
      const boundBot = boundBotByChannelId.get(channel.id) || null
      return { ...channel, boundBot, isDeployable: !boundBot }
    })
    .sort(byDeployableThenName)
}

function byDeployableThenName(left, right) {
  if (left.isDeployable !== right.isDeployable) return left.isDeployable ? -1 : 1
  return (left.name || '').localeCompare(right.name || '', undefined, { sensitivity: 'base' })
}
